import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import Accordion from 'LuxKit/Accordion'
import type { FaqItem } from '../api/weddings'

interface Props {
  qaItems: Array<FaqItem>
}

function WeddingFAQs(props: Props) {
  const { qaItems } = props

  if (qaItems.length === 0) {
    return null
  }

  return (
    <Group direction="vertical" gap={16} fullWidth>
      {qaItems.map((qa, index) => (
        <Accordion
          key={index}
          heading={qa.question}
          size="small"
        >
          <BodyText variant="large" wrap="pre-wrap">
            {qa.answer}
          </BodyText>
        </Accordion>
      ))}
    </Group>
  )
}

export default WeddingFAQs
